module.exports = __webpack_public_path__ + "static/media/calendar.645bde81.svg";